module.exports = __webpack_public_path__ + "img/18-days-voyage.e3d75b78.jpg";